export default __webpack_public_path__ + "static/media/faq_header.347bf178.jpg";